import { render } from "./ResidenceArea.vue?vue&type=template&id=5151eb94"
import script from "./ResidenceArea.vue?vue&type=script&lang=js"
export * from "./ResidenceArea.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__